export default __webpack_public_path__ + "maps-examples-clustering-thumbnail-960-1b004461a3c0c6eb8099e6fafd09522a.png";